import React from 'react';
import {
  SelectWrapper,
  StyledArrowSvg,
  StyledDropdown,
  DropdownContainer,
  DropdownContainerItem,
  StyledLabel,
  StyledText,
  SelecteStyledText,
} from '@components/SelectDropdown/SelectDropdown.styles';

export interface SelectProps<T> {
  className?: string;
  preSelectedOption: GalleryProductType;
  options: GalleryProductTypes;
  isOpen: boolean;
  handleOpen: (e: React.MouseEvent) => void;
  onClickedOption: (selectedOptions: GalleryProductType) => void;
}

export const SelectDropdown = <T extends string>({
  preSelectedOption,
  options,
  className,
  isOpen,
  handleOpen,
  onClickedOption,
}: SelectProps<T>) => {
  return (
    <SelectWrapper className={className}>
      <StyledDropdown isOpen={isOpen} onClick={(e) => handleOpen(e)}>
        <SelecteStyledText textAlign="center" variant="featureCopy17" color="neutra5" tagName="p">
          {preSelectedOption}
        </SelecteStyledText>
        <StyledArrowSvg isOpen={isOpen} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2525 8.80122C18.4868 9.03554 18.4868 9.41544 18.2525 9.64975L13.1312 14.7711C12.5063 15.3959 11.4933 15.3959 10.8684 14.7711L5.74898 9.65162C5.51466 9.41731 5.51466 9.03741 5.74898 8.80309C5.98329 8.56878 6.36319 8.56878 6.59751 8.80309L11.717 13.9225C11.8732 14.0788 12.1264 14.0788 12.2826 13.9225L17.404 8.80122C17.6383 8.56691 18.0182 8.56691 18.2525 8.80122Z"
            fill="#333333"
          />
        </StyledArrowSvg>
      </StyledDropdown>
      <DropdownContainer isOpen={isOpen}>
        {options.map((option, index) => (
          <DropdownContainerItem key={index}>
            <StyledLabel
              className="container"
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <input
                type="radio"
                checked={preSelectedOption === option}
                value={option}
                onChange={(event) => {
                  event.stopPropagation();
                  onClickedOption(option);
                }}
              />
              <StyledText left={'0'} textAlign="center" variant="caption" color="neutra6" tagName="p">
                {option}
              </StyledText>
            </StyledLabel>
          </DropdownContainerItem>
        ))}
      </DropdownContainer>
    </SelectWrapper>
  );
};
